<template>
  <button
    v-if="mdAndUp"
    type="button"
    class="menu-toggle-button shrink-0"
    data-test-id="menu-toggle-button"
    @click="drawerStore.isOpen = !drawerStore.isOpen"
  >
    <MaterialSymbolsLeftPanelCloseOutlineRounded
      v-if="drawerStore.isOpen"
      class="size-5"
    />
    <MaterialSymbolsLeftPanelOpenOutlineRounded v-else class="size-5" />
  </button>
  <div
    v-if="withSeparator"
    aria-hidden="true"
    class="mx-1 h-6 w-px shrink-0 bg-grey-200"
  />
</template>

<script lang="ts" setup>
import { useNavigationDrawerStore } from '@manager/store/navigation-drawer-store';
import { useDisplay } from 'vuetify';
import MaterialSymbolsLeftPanelCloseOutlineRounded from '~icons/material-symbols/left-panel-close-outline-rounded';
import MaterialSymbolsLeftPanelOpenOutlineRounded from '~icons/material-symbols/left-panel-open-outline-rounded';

withDefaults(
  defineProps<{
    withSeparator?: boolean;
  }>(),
  {
    withSeparator: true,
  }
);

const { mdAndUp } = useDisplay();
const drawerStore = useNavigationDrawerStore();
</script>

<style scoped lang="scss">
.menu-toggle-button {
  @apply flex h-8 w-8 items-center justify-center rounded text-grey-700 transition-colors;
}

.menu-toggle-button:hover {
  @apply text-app-primary;
}
</style>
